var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-vcentered is-mobile"},[_c('div',{staticClass:"column is-narrow"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/menu_logo.svg")}})]),_c('div',{staticClass:"column"}),_c('div',{staticClass:"column is-narrow"},[_vm._v(" (c) 2023 Unpredictables ")])])])])
}]

export { render, staticRenderFns }